import {get, post, formData } from '@/utils/common/http'
import { BASEURL } from '@/utils/common/config'

// export const a = function () {
// 	const url = BASEURL + ''
// 	return get(url)
// }

// export const b = function (param) {
// 	const url = BASEURL + ''
// 	return post(url, param)
// }



// 获取导航栏
export const menu = function(param) {
    const url = BASEURL + 'admin/menu/index'
    return post(url, param)
}

// 登录接口
export const login = function(param) {
        const url = BASEURL + 'admin/login'
        return post(url, param)
    }
    // 首页数据------------------------
export const show_data = function(param) {
    const url = BASEURL + 'admin/index/show_data'
    return get(url, param)
}
export const get_log_list = function(param) {
    const url = BASEURL + 'admin/index/get_log_list'
    return get(url, param)
}
export const get_month_log = function(param) {
    const url = BASEURL + 'admin/index/get_month_log'
    return get(url, param)
}




// 获取用户信息
export const getinfo = function(param) {
    const url = BASEURL + 'admin/getinfo'
    return post(url, param)
}

// 创建菜单
export const save_menu = function(param) {
    const url = BASEURL + 'admin/menu/save'
    return post(url, param)
}

// 删除菜单 
export const del_menu = function(param) {
    const url = BASEURL + 'admin/menu/del'
    return post(url, param)
}

// 修改菜单 
export const update_menu = function(param) {
    const url = BASEURL + 'admin/menu/update'
    return post(url, param)
}


// 获取角色列表
export const get_admin = function(param) {
    const url = BASEURL + 'admin/role/index'
    return get(url, param)
}

// 创建角色
export const add_admin = function(param) {
    const url = BASEURL + 'admin/role/save'
    return post(url, param)
}

//  修改角色   
export const up_admin = function(param) {
    const url = BASEURL + 'admin/role/update'
    return post(url, param)
}

//  删除角色   admin/menu/update
export const del_admin = function(param) {
    const url = BASEURL + 'admin/role/del'
    return post(url, param)
}

// 获取管理员 admin/index
export const get_user = function(param) {
    const url = BASEURL + 'admin/admin/index'
    return post(url, param)
}

// 创建管理员
export const add_user = function(param) {
    const url = BASEURL + 'admin/save'
    return post(url, param)
}

// 修改管理员 
export const up_user = function(param) {
    const url = BASEURL + 'admin/update'
    return post(url, param)
}

// 删除管理员
export const del_user = function(param) {
    const url = BASEURL + 'admin/del'
    return post(url, param)
}

// 修改自己的密码
export const resetPasswrod = function(param) {
    const url = BASEURL + 'admin/resetPasswrod'
    return post(url, param)
}

// 主题配置
export const config = function(param) {
    const url = BASEURL + 'admin/config'
    return post(url, param)
}

// 添加主题 adminadmin/addsetTheme
export const addsetTheme = function(param) {
    const url = BASEURL + 'adminadmin/addsetTheme'
    return post(url, param)
}

// 删除主题 adminadmin/delTheme
export const delTheme = function(param) {
    const url = BASEURL + 'adminadmin/delTheme'
    return post(url, param)
}

// 设为默认颜色  adminadmin/setTheme
export const setTheme = function(param) {
    const url = BASEURL + 'adminadmin/setTheme'
    return post(url, param)
}

// 获取文章列表  admin/article/index
export const article_list = function(param) {
    const url = BASEURL + 'admin/article/index'
    return get(url, param)
}

// 新增文章  admin/article/store
export const add_article = function(param) {
    const url = BASEURL + 'admin/article/store'
    return post(url, param)
}

// 删除文章  admin/article/del
export const del_article = function(param) {
    const url = BASEURL + 'admin/article/del'
    return post(url, param)
}

// 文件上传  使用formData  admin/upload
export const upload = function(param) {
    const url = BASEURL + 'admin/upload'
    return formData(url, param)
}

// 获取文章详情  admin/article/detail
export const article_article = function(param) {
    const url = BASEURL + 'admin/about/detail'
    return get(url, param)
}

// 编辑文章  admin/article/update
export const update_article = function(param) {
    const url = BASEURL + 'admin/about/update'
    return post(url, param)
}


// 获取关于我们 admin/about/index
export const get_about = function(param) {
    const url = BASEURL + 'admin/about/index'
    return get(url, param)
}

// 获取关于我们详情 admin/about/detail
export const get_about_detail = function(param) {
    const url = BASEURL + 'admin/about/detail'
    return get(url, param)
}

// 修改关于我们  admin/about/update
export const get_about_update = function(param) {
    const url = BASEURL + 'admin/about/update'
    return post(url, param)
}


// 获取轮播图 admin/banner/index  
export const get_banner = function(param) {
    const url = BASEURL + 'admin/banner/index'
    return get(url, param)
}

// 添加轮播图 admin/banner/store
export const add_banner = function(param) {
    const url = BASEURL + 'admin/banner/store'
    return post(url, param)
}

// 删除轮播图  admin/banner/del
export const del_banner = function(param) {
    const url = BASEURL + 'admin/banner/del'
    return post(url, param)
}

// 修改轮播图 admin/banner/update
export const upd_banner = function(param) {
    const url = BASEURL + 'admin/banner/update'
    return post(url, param)
}


// 获取地区   admin/city
export const get_city = function(param) {
        const url = BASEURL + 'admin/city'
        return post(url, param)
    }
    // 分享   admin/city
export const get_share = function(param) {
        const url = BASEURL + 'admin/share_page_config/index'
        return get(url, param)
    }
    // 分享   admin/city
export const update_share = function(param) {
        const url = BASEURL + 'admin/share_page_config/update'
        return post(url, param)
    }
    // ip登录日志  
export const ip_log = function(param) {
    const url = BASEURL + 'admin/admin/log'
    return get(url, param)
}


// WEBPACK FOOTER //
// ./src/utils/api/index.js